import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const LabelOperacion = ( { idSolicitud, location, idAgente }) => {

  const [labelPosition, setLabelPosition] = useState('');
  const role = localStorage.getItem('role');

  useEffect(() => {
    chooseLabelPosition(location)
  }, [location])
  
  const chooseLabelPosition = (state) => {
    setLabelPosition(state);
  }

  return (
    <>
    <ul className="nav">
    {  role !== 'AGA' ?
    <>
    <li className="nav-item">
    <Link  to={`/perfil-agente/${idAgente}/detalle-operaciones/${idSolicitud}/#contenedores`} className="nav-link">
        Contenedores
        { labelPosition === '#contenedores' && <hr style={{border: ' 1px solid blue'}} /> }
    </Link>
    </li>
    <li className="nav-item">
    <Link  to={`/perfil-agente/${idAgente}/detalle-operaciones/${idSolicitud}/#registro-de-tiempos`} className="nav-link">
        Registro de tiempos
        { labelPosition === '#registro-de-tiempos' && <hr style={{border: ' 1px solid blue'}} /> }
    </Link>
    </li>
    <li className="nav-item">
    <Link  to={`/perfil-agente/${idAgente}/detalle-operaciones/${idSolicitud}/#demoras`} className="nav-link">
        Demoras
        { labelPosition === '#demoras' && <hr style={{border: ' 1px solid blue'}} /> }
    </Link>
    </li>
    <li className="nav-item">
    <Link  to={`/perfil-agente/${idAgente}/detalle-operaciones/${idSolicitud}/#comentarios`} className="nav-link" >
        Comentarios
        { labelPosition === '#comentarios' && <hr style={{border: ' 1px solid blue'}} /> }
      </Link>
    </li>
    </>
    :
    <>
    <li className="nav-item">
    <Link  to={`/detalle-operaciones/${idSolicitud}/#contenedores`} className="nav-link">
        Contenedores
        { labelPosition === '#contenedores' && <hr style={{border: ' 1px solid blue'}} /> }
    </Link>
    </li>
    <li className="nav-item">
    <Link  to={`/detalle-operaciones/${idSolicitud}/#registro-de-tiempos`} className="nav-link">
        Registro de tiempos
        { labelPosition === '#registro-de-tiempos' && <hr style={{border: ' 1px solid blue'}} /> }
    </Link>
    </li>
    <li className="nav-item">
    <Link  to={`/detalle-operaciones/${idSolicitud}/#demoras`} className="nav-link">
        Demoras
        { labelPosition === '#demoras' && <hr style={{border: ' 1px solid blue'}} /> }
    </Link>
    </li>
    <li className="nav-item">
    <Link  to={`/detalle-operaciones/${idSolicitud}/#comentarios`} className="nav-link" >
        Comentarios
        { labelPosition === '#comentarios' && <hr style={{border: ' 1px solid blue'}} /> }
      </Link>
    </li>
    </>
    }
  </ul>
    
  <hr className='nav_linea_selector' />
  </>
  )
}

export default LabelOperacion